module.exports = __webpack_public_path__ + "img/cash-remove-color.69e0af5c.svg";